/**
 * 侧栏菜单树（父子结构）
 * 叶子节点带 component；父节点仅作分组
 */
export const menuTree = [
  {
    path: '/dashboard',
    name: 'Dashboard',
    meta: { title: '仪表盘', icon: 'dashboard' },
    component: () => import('@/views/dashboard/index.vue')
  },
  {
    path: '/statistics',
    name: 'Statistics',
    meta: { title: '数据统计', icon: 'bar-chart', action: 'statistics' },
    component: () => import('@/views/statistics/list.vue')
  },
  {
    path: '/ops',
    name: 'Ops',
    meta: { title: '运营中心', icon: 'appstore' },
    children: [
      {
        path: '/banner',
        name: 'Banner',
        meta: { title: 'Banner管理', icon: 'picture', action: 'banner' },
        component: () => import('@/views/banner/list.vue')
      },
      {
        path: '/notification',
        name: 'Notification',
        meta: { title: '通知公告', icon: 'notification', action: 'notification' },
        component: () => import('@/views/announcement/list.vue')
      },
      {
        path: '/appVersion',
        name: 'AppVersion',
        meta: { title: '应用版本', icon: 'mobile', action: 'appversion' },
        component: () => import('@/views/appVersion/list.vue')
      },
      {
        path: '/push',
        name: 'Push',
        meta: { title: '消息推送', icon: 'mail', action: 'push' },
        component: () => import('@/views/push/list.vue')
      }
    ]
  },
  {
    path: '/content',
    name: 'Content',
    meta: { title: '内容中心', icon: 'read' },
    children: [
      {
        path: '/collect',
        name: 'Collect',
        meta: { title: '藏品管理', icon: 'database', action: 'collect' },
        component: () => import('@/views/collect/list.vue')
      },
      {
        path: '/article',
        name: 'Article',
        meta: { title: '文章管理', icon: 'file-text', action: 'article' },
        component: () => import('@/views/article/list.vue')
      },
      {
        path: '/country',
        name: 'Country',
        meta: { title: '国家管理', icon: 'global', action: 'country' },
        component: () => import('@/views/country/list.vue')
      },
      {
        path: '/dynasty',
        name: 'Dynasty',
        meta: { title: '朝代字典', icon: 'history', action: 'dynasty' },
        component: () => import('@/views/dynasty/list.vue')
      },
      {
        path: '/contribution',
        name: 'Contribution',
        meta: { title: '投稿审核', icon: 'audit', action: 'contribution' },
        component: () => import('@/views/contribution/list.vue')
      },
      {
        path: '/correction',
        name: 'Correction',
        meta: { title: '纠错审核', icon: 'form', action: 'correction' },
        component: () => import('@/views/correction/list.vue')
      }
    ]
  },
  {
    path: '/member',
    name: 'Member',
    meta: { title: '用户中心', icon: 'team' },
    children: [
      {
        path: '/user',
        name: 'User',
        meta: { title: '用户列表', icon: 'user', action: 'user' },
        component: () => import('@/views/user/list.vue')
      },
      {
        path: '/membership',
        name: 'Membership',
        meta: { title: '会员产品', icon: 'gift', action: 'membership' },
        component: () => import('@/views/membership/list.vue')
      },
      {
        path: '/order',
        name: 'Order',
        meta: { title: '会员订单', icon: 'account-book', action: 'order' },
        component: () => import('@/views/order/list.vue')
      },
      {
        path: '/feedback',
        name: 'Feedback',
        meta: { title: '用户反馈', icon: 'message', action: 'feedback' },
        component: () => import('@/views/feedback/list.vue')
      }
    ]
  },
  {
    path: '/system',
    name: 'System',
    meta: { title: '系统管理', icon: 'setting' },
    children: [
      {
        path: '/account',
        name: 'AccountManage',
        meta: { title: '账号管理', icon: 'user', action: 'admin' },
        component: () => import('@/views/admin/account.vue')
      },
      {
        path: '/role',
        name: 'RoleManage',
        meta: { title: '角色管理', icon: 'team', action: 'admin' },
        component: () => import('@/views/admin/role.vue')
      },
      {
        path: '/action',
        name: 'ActionManage',
        meta: { title: '权限路径', icon: 'key', action: 'admin' },
        component: () => import('@/views/admin/action.vue')
      },
      {
        path: '/sms',
        name: 'SmsLog',
        meta: { title: '短信日志', icon: 'mobile', action: 'sms' },
        component: () => import('@/views/sms/list.vue')
      },
      {
        path: '/sysLog',
        name: 'SysLog',
        meta: { title: '系统日志', icon: 'profile', action: 'syslog' },
        component: () => import('@/views/sysLog/list.vue')
      },
      {
        path: '/setting',
        name: 'Setting',
        meta: { title: '系统配置', icon: 'tool', action: 'setting' },
        component: () => import('@/views/setting/list.vue')
      },
      {
        path: '/document',
        name: 'Document',
        meta: { title: '协议政策', icon: 'file-protect', action: 'document' },
        component: () => import('@/views/document/list.vue')
      },
      {
        path: '/monitor',
        name: 'SystemMonitor',
        meta: { title: '系统监控', icon: 'cloud-server', action: 'monitor' },
        component: () => import('@/views/monitor/index.vue')
      }
    ]
  }
]

export function hasActionPermission (actions, code) {
  if (!code) {
    return true
  }
  const list = actions || []
  if (list.includes(code)) {
    return true
  }
  const prefix = code + ':'
  return list.some(a => typeof a === 'string' && a.startsWith(prefix))
}

/**
 * 按权限过滤菜单树；无权限子节点的父级不展示
 */
export function filterMenusByActions (actions) {
  return menuTree
    .map(node => {
      if (node.children && node.children.length) {
        const children = node.children.filter(c =>
          hasActionPermission(actions, c.meta && c.meta.action)
        )
        if (!children.length) {
          return null
        }
        return { ...node, children }
      }
      if (!hasActionPermission(actions, node.meta && node.meta.action)) {
        return null
      }
      return node
    })
    .filter(Boolean)
}

/** 展平叶子路由（供动态注册） */
export function flattenMenuRoutes (menus) {
  const list = []
  ;(menus || []).forEach(node => {
    if (node.children && node.children.length) {
      node.children.forEach(c => list.push(c))
    } else if (node.component) {
      list.push(node)
    }
  })
  return list
}

/** @deprecated 兼容旧引用 */
export const asyncMenuRoutes = flattenMenuRoutes(menuTree)
